<template lang="pug">
section.LndTeam.d-flex.--spread(:class="mq.sm && '--col'")
  .d-flex.--col
    .d-flex.__head.--middle
      Svgi(name="team")
      h2(v-html="header")
    .__contents
      p(v-for="text of contents", v-html="text")

  ul.d-flex.--wrap.__people
    li(v-for="peop of people")
      img(:src="peoplePhotos[peop.$id]")
      span.__info
        span.__name(v-html="peop.name")
        span.__title(v-html="peop.title")
</template>
<script>
import content from 'content';

export default {
  name: 'LndTeam',
  inject: ['mq'],

  static: () => ({
    ...content.team,
    peoplePhotos: {
      romaOsokin: require('assets/people/romaOsokin.png'),
      mayyaKim: require('assets/people/mayyaKim.png'),
      klimChe: require('assets/people/klimChe.png'),
      polinaPavlova: require('assets/people/polinaPavlova.png'),
      arinaLyakh: require('assets/people/arinaLyakh.png'),
      andrewButko: require('assets/people/andrewButko.png'),
    },
  }),
};

</script>
<style>
.LndTeam {
  --gap-h: calc(120 / var(--vw-scale));

  > * {
    flex-basis: 48%;
    flex-grow: 2;
  }

  .__head {
    --gap-h: 30px;

    margin-bottom: 50px;

    svg {
      width: 50px;
      height: 50px;
    }
  }

  .__contents {
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: -0.01em;

    p:not(:last-child) { margin-bottom: 2em; }
  }

  .__people {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 32px;

    > li {
      display: flex;
      gap: 16px;
    }

    img {
      width: 79px;
      height: 79px;

      border-radius: 50%;
    }

    .__info {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .__name {
      font-weight: 500;
      font-size: 20px;
      line-height: 35px;
      letter-spacing: -0.01em;
    }

    .__title {
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: -0.01em;
    }
  }
}

@media (max-width: 1023px) {
  .LndTeam {
    --gap-v: 50px;

    .__people {
      grid-template-columns: 1fr;
    }
  }
}
</style>
